module.exports = __webpack_public_path__ + "img/kufri-ecru.64fce68.webp";